import React, { useState, useRef } from "react";
import { t } from "i18next";
import Button from "@mui/material/Button";
import {
	answerTypes,
	ANSWERS_CONVERSATION_FORMAT,
	STEP_TYPES
} from "components/Custom/AnswerTypeDialog/constants";
import DialogContact from "../../DialogContact";
import DialogGoogleMap from "../../GoogleMap/DiaglogGoogleMap/DialogGoogleMap";
import DialogLink from "../../DialogLink";
import DialogSurvey from "../../DialogSurvey";
import FileUploader from "./FileUploader";

const MenuTypology = ({
	onTypeChange,
	fileInputRef,
	typologyType,
	language,
	code,
	stepTypeSelected,
	menu
}) => {
	const [onOpenGoogleMap, setOnOpenGoogleMap] = useState(false);
	const [onOpenDialogContact, setOnOpenDialogContact] = useState(false);
	const [onOpenDialogLink, setOnOpenDialogLink] = useState(false);
	const [onOpenDialogSurvey, setOnOpenDialogSurvey] = useState(false);
	const internalFileInputRef = useRef(null);

	const isSolutionType = stepTypeSelected === STEP_TYPES.solution;
	const surveyDialogTitle = t(
		menu
			? isSolutionType
				? "LABELS.editSolution"
				: "LABELS.editSurvey"
			: isSolutionType
				? "LABELS.addSolution"
				: "LABELS.addSurvey"
	);

	const handleTypeSelect = type => {
		if (type === ANSWERS_CONVERSATION_FORMAT.location) {
			setOnOpenGoogleMap(true);
		}
		if (type === ANSWERS_CONVERSATION_FORMAT.contact) {
			setOnOpenDialogContact(true);
		}
		if (type === ANSWERS_CONVERSATION_FORMAT.link) {
			setOnOpenDialogLink(true);
		}
		if (type === ANSWERS_CONVERSATION_FORMAT.menu) {
			setOnOpenDialogSurvey(true);
		}
		if (type === ANSWERS_CONVERSATION_FORMAT.document) {
			(fileInputRef || internalFileInputRef).current.click();
		}
	};

	return (
		<>
			<div style={{ display: "flex", padding: "20px" }}>
				{answerTypes
					.filter(it => it.type === typologyType)
					.filter(t => t.type !== ANSWERS_CONVERSATION_FORMAT.richtext)
					.map(item => (
						<Button
							key={item.type}
							startIcon={item.icon}
							onClick={() => handleTypeSelect(item.type)}
							sx={{
								borderColor: "#ccc",
								color: "#666",
								borderRadius: "20px",
								padding: "6px 16px",
								marginRight: "10px",
								textTransform: "none",
								fontSize: "14px",
								border: "1px solid #ccc"
							}}
						>
							{isSolutionType ? t("LABELS.stepTypeSelected") : t(item.label)}
						</Button>
					))}
			</div>

			<FileUploader
				onTypeChange={(file, value) => {
					onTypeChange?.(ANSWERS_CONVERSATION_FORMAT.document, { attachments: [value] });
				}}
				fileInputRef={fileInputRef || internalFileInputRef}
				language={language}
				code={code}
			/>

			{onOpenDialogContact && (
				<DialogContact
					onClose={() => setOnOpenDialogContact(false)}
					onAddContact={contact =>
						onTypeChange?.(ANSWERS_CONVERSATION_FORMAT.contact, {
							[ANSWERS_CONVERSATION_FORMAT.contact]: contact
						})
					}
				/>
			)}
			{onOpenGoogleMap && (
				<DialogGoogleMap
					onClose={() => setOnOpenGoogleMap(false)}
					onAddLocation={location => onTypeChange?.(ANSWERS_CONVERSATION_FORMAT.location, location)}
				/>
			)}
			{onOpenDialogLink && (
				<DialogLink
					onClose={() => setOnOpenDialogLink(false)}
					onAddLink={link => onTypeChange?.(ANSWERS_CONVERSATION_FORMAT.link, link)}
				/>
			)}
			{onOpenDialogSurvey && (
				<DialogSurvey
					onClose={() => setOnOpenDialogSurvey(false)}
					onAddSurvey={menu => {
						const choices = menu?.menu?.choices?.filter(it => it.label !== "");
						const value = { menu: { ...menu?.menu, choices } };
						onTypeChange?.(ANSWERS_CONVERSATION_FORMAT.menu, value);
					}}
					menu={menu}
					title={surveyDialogTitle}
					isSolutionType={isSolutionType}
				/>
			)}
		</>
	);
};

export default MenuTypology;
